import PointActivityPage from "./PointActivityPage";

export default PointActivityPage;